export const fields = {
  sku: {
    label: 'SKU',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'sku',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'sku',
    rules: {
      title: 'SKU field',
      required: true,
    }
  },
  name: {
    label: 'Name',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Name field',
      required: true,
    }
  },
  cost: {
    prefix: '$',
    label: 'Cost',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'cost',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'cost',
    rules: {
      title: 'Cost field',
      required: true,
    }
  },
  price: {
    prefix: '$',
    label: 'Price',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'price',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'price',
    rules: {
      title: 'Price field',
      required: true,
    }
  },
  vendor: {
    label: 'Vendor',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'vendor_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'vendor',
    rules: {
      title: 'Vendor field',
      required: true,
    }
  },
  unit_of_measure: {
    label: 'Unit of measure',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'unit_of_measure',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'unit_of_measure',
    rules: {
      title: 'Unit of measure field',
    }
  },
  notes: {
    label: 'Notes',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'notes',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'notes',
    rules: {
      title: 'Notes field',
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/MaterialEdit/fields.js